import client from "services/ngage/api-client";

/**
 * Permanently delete an event series
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/events/${id}/series`)
    return response.status === 204
}

const eventSeries = {
    destroy
}

export default eventSeries;